import script from "./PartFour.vue?vue&type=script&setup=true&lang=js"
export * from "./PartFour.vue?vue&type=script&setup=true&lang=js"

import "./PartFour.vue?vue&type=style&index=0&id=815a853a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-815a853a"]])

export default __exports__